$(document).ready(function() {

  // Mascaras
  var SPMaskBehavior = function(val) {
      return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    spOptions = {
      onKeyPress: function(val, e, field, options) {
        field.mask(SPMaskBehavior.apply({}, arguments), options);
      }
    };
  $('#premio_wme_cpf').mask('000.000.000-00');
  $('#premio_wme_data-nascimento').mask('00/00/0000');

  // Método para validar CPF
  jQuery.validator.addMethod("cpf", function(value, element) {
    value = jQuery.trim(value);
    value = value.replace('.', '');
    value = value.replace('.', '');
    value = value.replace('-', '');
    while (value.length < 11) value = "0" + value;
    var expReg = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;
    var a = [];
    var b = new Number;
    var c = 11;
    var i = "";
    var x = "";
    var y = "";
    for (i = 0; i < 11; i++) {
      a[i] = value.charAt(i);
      if (i < 9) b += (a[i] * --c);
    }
    if ((x = b % 11) < 2) {
      a[9] = 0
    } else {
      a[9] = 11 - x
    }
    b = 0;
    c = 11;
    for (y = 0; y < 10; y++) b += (a[y] * c--);
    if ((x = b % 11) < 2) {
      a[10] = 0;
    } else {
      a[10] = 11 - x;
    }

    var retorno = true;
    if ((value.charAt(9) != a[9]) || (value.charAt(10) != a[10]) || value.match(expReg)) retorno = false;

    return this.optional(element) || retorno;

  }, "Informe um CPF válido."); // Mensagem padrão

  // Validação
  $("form#cadastro").validate({
    rules: {
      'premio_wme_nome': {
        required: true
      },
      'premio_wme_email': {
        required: true,
        email: true
      },
      'premio_wme_data-nascimento': {
        required: true
      },
      'premio_wme_rg': {
        required: true
      },
      'premio_wme_cpf': {
        required: true,
        cpf: true
      },
      'premio_wme_endereco': {
        required: true
      },
      'premio_wme_instagram': {
        required: true
      },
      'premio_wme_facebook': {
        required: true
      },
      'premio_wme_youtube': {
        required: true
      },
      'premio_wme_aceite_niely': {
        required: true
      }
    },
    messages: {
      'premio_wme_nome': {
        required: "Informe seu nome"
      },
      'premio_wme_email': {
        required: "Informe seu e-mail",
        email: "Informe um email válido"
      },
      'premio_wme_data-nascimento': {
        required: "Informe sua data de nascimento"
      },
      'premio_wme_rg': {
        required: "Informe o número do seu RG"
      },
      'premio_wme_cpf': {
        required: "Informe o número do seu CPF",
        cpf: "Informe um número de CPF válido"
      },
      'premio_wme_endereco': {
        required: "Informe seu endereço"
      },
      'premio_wme_instagram': {
        required: "Informe seu Instagram"
      },
      'premio_wme_facebook': {
        required: "Informe seu Facebook"
      },
      'premio_wme_youtube': {
        required: "Informe o link de seu canal no Youtube"
      },
      'premio_wme_aceite_niely': {
        required: "Você precisa aceitar ter suas informações compartilhadas com a Niely"
      }
    },
  });
});